import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { UiRepository } from 'app/state/ui.repository';
import { BackNavigationService } from 'app/helpers/services/backButtonNavigationService';
import { combineLatest, fromEvent, map, Observable, startWith } from 'rxjs';
import { UiEventsService } from 'app/api/services/signal.service';

@Component({
  selector: 'app-headermenu',
  templateUrl: './headermenu.component.html',
  styleUrls: ['./headermenu.component.scss'],
})
export class HeadermenuComponent implements OnInit {
  page: string | null = null;
  showBackArrow$!: Observable<boolean>;
  isPilot: boolean = false;
  constructor(
    public navigationService: BackNavigationService,
    public repo: UiRepository,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private uiEvents: UiEventsService,
  ) {
    this.route.queryParams.subscribe((x) => this.initShowBackArrow());
  }

  backnav() {
    this.isPilot = this.router.url.includes('pilot');
    if (this.isPilot) {
      this.uiEvents.emitAction();
      return true;
    } else {
      this.navigationService.goBack();

      return false;
    }
  }

  ngOnInit(): void {
    this.showBackArrow$ = this.initShowBackArrow();
  }

  isRoute(route: string) {
    return this.router.url.includes(route);
  }

  initShowBackArrow(): Observable<boolean> {
    const guidRegex =
      /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;

    const url$ = this.router.events.pipe(
      startWith(this.router.url),
      map(() => this.router.url),
    );

    const resize$ = fromEvent(window, 'resize').pipe(
      startWith(window.innerWidth),
      map(() => window.innerWidth <= 768),
    );

    return combineLatest([url$, resize$]).pipe(
      map(([currentUrl, isMobile]) => {
        const hasGuid = guidRegex.test(currentUrl);
        return (
          !this.isRoute('/home') &&
          (hasGuid || isMobile || this.isRoute('/new'))
        );
      }),
    );
  }
}
